module.exports = __webpack_public_path__ + "img/hero5.3d9dd6f4.jpg";